module.exports = __webpack_public_path__ + "static/media/target.70f8c9dc.png";